import { useState, useCallback } from 'react';
import { authApi } from '@/sdk/shared';
import type { RegisterRequest, RegisterResponse, ApiError } from '../types';

interface UseRegisterReturn {
  register: (data: RegisterRequest) => Promise<RegisterResponse>;
  isLoading: boolean;
  error: ApiError | null;
  clearError: () => void;
}

export const useRegister = (): UseRegisterReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<ApiError | null>(null);

  const register = useCallback(async (data: RegisterRequest): Promise<RegisterResponse> => {
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await authApi.register(data);
      return response;
    } catch (err) {
      const error = err as ApiError;
      setError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    register,
    isLoading,
    error,
    clearError,
  };
};
